import React, { useState } from 'react'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { storageFactory } from 'storage-factory'
import LotesCardDesktop from 'Components/LotesCardDesktop'
import { useIsMobile } from 'utils/Utils'
import LotesCardMobile from 'Components/LotesCardMobile'
import { useApi } from 'ApiHooks'
import { useBlockUI } from 'Context/BlockUIContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faBoxes } from '@fortawesome/free-solid-svg-icons'
import { useErrorModal } from 'Context/ErrorModalContext'
import { fechaActual, fechaUnMesAtras } from 'Utilidades'
import { Lote } from 'Interfaces/LoteBusqueda'
import ModalVerEstadoDespacho from 'Components/ModalVerEstadoDespacho'

const Lotes = () => {

    const api = useApi()
    const storage = storageFactory(() => localStorage)
    const { showBlock, hideBlock } = useBlockUI()
    const { showError } = useErrorModal()
    const declaranteActual = storage.getItem("declaranteSeleccionado")
    const nombreDeclaranteActual = storage.getItem("nombreDeclaranteSeleccionado")
    type FiltroLotes = 'Cerrados' | 'Procesados' | 'Anulados' | 'Todos'
    const isMobile = useIsMobile()
    const [filtro, setFiltro] = useState<FiltroLotes>('Todos')
    const [filtroAplicado, setFiltroAplicado] = useState<FiltroLotes>('Cerrados')
    const [fechaDesde, setFechaDesde] = useState<string>(fechaUnMesAtras())
    const [fechaHasta, setFechaHasta] = useState<string>(fechaActual())
    const [despachoInput, setDespachoInput] = useState<string | null>(null)
    const [busquedaRealizada, setBusquedaRealizada] = useState<boolean>(false)
    const [paginaActual, setPaginaActual] = useState(1)
    const [pageSize] = useState(50)
    const [totalRegistros, setTotalRegistros] = useState(0)
    const [lotes, setLotes] = useState<Lote[]>([])
    const [showModalVerEstado, setShowModalVerEstado] = useState(false)
    const totalPaginas = Math.ceil(totalRegistros / pageSize)

    const PageHeader = () => (
        <Card className="mb-4 shadow-sm border-0">
            <Card.Body className="d-flex justify-content-between align-items-center flex-wrap">
                <div>
                    <h4 className="text-muted mb-3">
                        <Button variant='warning' className='mr-3' onClick={() => window.location.href = "/selectDeclarante"}><FontAwesomeIcon icon={faArrowLeft} /></Button>

                        Despachante: <strong>{declaranteActual} - {nombreDeclaranteActual}</strong>
                    </h4>
                    <h3 className="mb-0 mt-1 d-flex align-items-center gap-2 fw-semibold">
                        <FontAwesomeIcon icon={faBoxes} size="lg" className='mr-3' />
                        Lotes
                    </h3>
                </div>
                <Button
                    variant="primary"
                    className="mt-3 mt-md-0"
                    onClick={() => {
                        setShowModalVerEstado(true)
                    }}
                >
                    Ver Estado
                </Button>
            </Card.Body>
        </Card>
    )

    const obtenerLotesPaginado = async (pagina = 1) => {
        showBlock("Cargando lotes...")
        try {
            const lotesObtenidos = await api.getLotesBusquedaPaginado({
                CuitDespachante: declaranteActual!,
                FechaIni: fechaDesde,
                FechaFin: fechaHasta,
                EstadoNombre: filtroAplicado,
                Pagina: pagina,
                Orden: 1,
                Despacho: despachoInput?.length! > 0 ? despachoInput : null
            })

            setBusquedaRealizada(true)
            setTotalRegistros(lotesObtenidos.cantidadTotal)
            setLotes(lotesObtenidos.listaLotes)
            setPaginaActual(pagina)
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al cargar datos',
                    message:
                        error?.response?.status === 401
                            ? 'Se ha vencido el tiempo de la sesión'
                            : error?.response?.data?.message,
                })
            }
        } finally {
            hideBlock()
        }
    }


    return (
        <Container fluid className="p-4 bg-light">
            <PageHeader />

            <Card className="mb-4 shadow-sm border-0">
                <Card.Body>
                    <Row className="align-items-end">
                        <Col md={4}>
                            <label className="fw-bold mb-1"><b>Tipo de lote</b></label>
                            <select
                                className="form-control"
                                value={filtro}
                                onChange={(e) => {
                                    setBusquedaRealizada(false)
                                    setLotes([])
                                    setFiltro(e.target.value as FiltroLotes)
                                    setFiltroAplicado(e.target.value as FiltroLotes)
                                }}
                            >
                                <option value="Todos">Todos</option>
                                <option value="Cerrados">Lotes Cerrados</option>
                                <option value="Procesados">Procesados</option>
                                <option value="Anulados">Lotes Anulados</option>
                            </select>
                        </Col>
                        <Col md="auto">
                            <label className="fw-bold mb-1"><b>Fecha Desde</b></label>
                            <Form.Control
                                type="date"
                                defaultValue={fechaUnMesAtras()}
                                value={fechaDesde}
                                onChange={(e) => setFechaDesde(e.target.value)}
                            />
                        </Col>
                        <Col md="auto">
                            <label className="fw-bold mb-1"><b>Fecha Hasta</b></label>
                            <Form.Control
                                type="date"
                                defaultValue={fechaActual()}
                                value={fechaHasta}
                                onChange={(e) => setFechaHasta(e.target.value)}
                            />
                        </Col>
                        <Col md="auto">
                            <label className="fw-bold mb-1"><b>Despacho</b></label>
                            <Form.Control
                                type="text"
                                value={despachoInput ?? ''}
                                onChange={(e) => setDespachoInput(e.target.value)}
                            />
                        </Col>
                        <Col md="auto">
                            <Button
                                variant="primary"
                                className="mt-3 mt-md-0"
                                onClick={() => {
                                    obtenerLotesPaginado()
                                    setFiltroAplicado(filtro)
                                }}
                            >
                                Buscar
                            </Button>

                            <Button variant="primary" style={{ marginTop: isMobile ? 15 : 0, marginLeft: 15 }} onClick={() => window.location.href = "/altaPedidoGuia"}>
                                <a href='/altaPedidoGuia' style={{ textDecoration: 'none', color: 'white' }}>
                                    + Nuevo Lote
                                </a>
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <ModalVerEstadoDespacho
                onClose={() => setShowModalVerEstado(false)}
                showModalVerEstadoDespacho={showModalVerEstado}
                setShowModalVerEstadoDespacho={setShowModalVerEstado}
            />
            {busquedaRealizada && <Row className="align-items-start">
                {(filtroAplicado === 'Todos') && <Col lg={12} className="mb-4">
                    {isMobile ? <LotesCardMobile
                        title="Lotes"
                        variant="secondary"
                        data={lotes}
                        totalPaginas={totalPaginas}
                        paginaActual={paginaActual}
                        obtenerLotesPaginado={obtenerLotesPaginado} /> : <LotesCardDesktop
                        title="Lotes"
                        variant="secondary"
                        data={lotes}
                        totalPaginas={totalPaginas}
                        paginaActual={paginaActual}
                        obtenerLotesPaginado={obtenerLotesPaginado}
                    />}
                </Col>}
                {(filtroAplicado === 'Cerrados') && <Col lg={12} className="mb-4">
                    {isMobile ? <LotesCardMobile
                        title="Lotes Cerrados"
                        variant="primary"
                        data={lotes}
                        totalPaginas={totalPaginas}
                        paginaActual={paginaActual}
                        obtenerLotesPaginado={obtenerLotesPaginado} /> : <LotesCardDesktop
                        title="Lotes Cerrados"
                        variant="primary"
                        data={lotes}
                        totalPaginas={totalPaginas}
                        paginaActual={paginaActual}
                        obtenerLotesPaginado={obtenerLotesPaginado}
                    />}
                </Col>}

                {(filtroAplicado === 'Procesados') && <Col lg={12} className="mb-4">
                    {isMobile ? <LotesCardMobile
                        title="Procesados"
                        variant="success"
                        data={lotes}
                        totalPaginas={totalPaginas}
                        paginaActual={paginaActual}
                        obtenerLotesPaginado={obtenerLotesPaginado} /> : <LotesCardDesktop
                        title="Procesados"
                        variant="success"
                        data={lotes}
                        totalPaginas={totalPaginas}
                        paginaActual={paginaActual}
                        obtenerLotesPaginado={obtenerLotesPaginado}
                    />}
                </Col>}

                {(filtroAplicado === 'Anulados') && <Col lg={12} className="mb-4">
                    {isMobile ? <LotesCardMobile
                        title="Lotes Anulados"
                        variant="danger"
                        data={lotes}
                        totalPaginas={totalPaginas}
                        paginaActual={paginaActual}
                        obtenerLotesPaginado={obtenerLotesPaginado} /> : <LotesCardDesktop
                        title="Lotes Anulados"
                        variant="danger"
                        data={lotes}
                        totalPaginas={totalPaginas}
                        paginaActual={paginaActual}
                        obtenerLotesPaginado={obtenerLotesPaginado}
                    />}
                </Col>}
            </Row>}
        </Container>

    )
}

export default Lotes